module.exports = __webpack_public_path__ + "static/media/onscreen_credits_1080_tr.b6327d84.png";